import React, {useEffect} from "react";
import {Redirect} from "react-router";
import {useApplicationRootUrl} from "common/component/ApplicationRootContext";
import {useCurrentUser} from "../../security";
import {firstAccessibleRoute, NO_ACCESS_REDIRECT_URL} from "../domain/accessMap";
import {useAccessMap} from "../domain/useAccessMap";

/**
 * Sends a provider to their highest-priority reachable page. Used for the index landing
 * and as the bounce target when a route guard denies access. A user who can reach nothing
 * is sent (full-page) to the configured no-access URL — never while `currentUser` is loading.
 */
export const ProviderConditionalRedirect = () => {
    const currentUser = useCurrentUser();
    const rootUrl = useApplicationRootUrl();
    const route = firstAccessibleRoute(currentUser, useAccessMap());

    useEffect(() => {
        if (currentUser && route === null) {
            window.location.assign(NO_ACCESS_REDIRECT_URL);
        }
    }, [currentUser, route]);

    if (route !== null) {
        return <Redirect to={`${rootUrl}${route}`}/>;
    }

    // currentUser still loading (render nothing), or the zero-access bounce above is in flight.
    return null;
};
